(function () {
    window.app = window.app || {};
    var prices = function () {
        var overalItemsPrice = 0,
            deliveryPrice = 0,
            couponPrice = 0,
            fullPrice = overalItemsPrice + deliveryPrice - couponPrice;
        var callbacks = [];
        this.onFieldChanged = function (callback) {
            callbacks.push(callback);
        };
        Object.defineProperty(this, "overalItemsPrice", {
            get: function () {
                return overalItemsPrice;
            },
            set: function (value) {
                overalItemsPrice = value;
                this.fieldChanged();
            }
        });
        Object.defineProperty(this, "deliveryPrice", {
            get: function () {
                return deliveryPrice;
            },
            set: function (value) {
                deliveryPrice = value;
                this.fieldChanged();
            }
        });
        Object.defineProperty(this, "couponPrice", {
            get: function () {
                return couponPrice;
            },
            set: function (value) {
                couponPrice = value;
                this.fieldChanged();
            }
        });
        Object.defineProperty(this, "fullPrice", {
            get: function () {
                return fullPrice;
            }
        });
        this.fieldChanged = function () {
            fullPrice = parseInt(overalItemsPrice) + parseInt(deliveryPrice) + parseInt(parseInt(overalItemsPrice) * parseInt(couponPrice) / 100);
            for (var i in callbacks) {
                (function (i) {
                    setTimeout(callbacks[i], 0);
                })(i);
            }
        };
    };
    window.app.prices = new prices;
})();

(function () {
    if (window.app !== undefined && window.app.prices !== undefined) {
        window.app.prices.onFieldChanged(function () {
            $('.js-to-paid').html(formatNumber(window.app.prices.fullPrice, 0, ',', ' ') + '&nbsp;₽');
        });
    }
})();

(function (window, $) {
    var DeliveryMethods = function () {
        var _data = [];
        this.eventHandlers = {};

        Object.defineProperty(this, "methods", {
            get: function () {
                return _data;
            }
        });

        this.setData = function (data) {
            _data = data;
        };
    };
    DeliveryMethods.prototype.on = function (eventName, handler) {
        var self = this;
        if (typeof (self.eventHandlers[eventName]) === "undefined") {
            self.eventHandlers[eventName] = [];
        }
        self.eventHandlers[eventName].push(handler);
    };

    DeliveryMethods.prototype.fire = function (eventName, eventData) {
        var self = this;
        if (typeof (self.eventHandlers[eventName]) !== "undefined") {
            for (var i in self.eventHandlers[eventName]) {
                setTimeout(function () {
                    self.eventHandlers[eventName][i](eventData);
                }, 0);
            }
        }
    };
    DeliveryMethods.prototype.refresh = function (data) {
        var self = this;
        $.ajax({
            dataType: 'json',
            url: "/catalog/getDeliveryMethods",
            data: data,
            success: function (data) {
                self.setData(data);
                self.fire("afterRefresh");
            },
            error: function () {
                var default_price = 300;

                //Акция бесплатная доставка при предоплате от 21.11.2019
                /*
                if(data.payMethodId === '2'){
                    default_price = 0;
                }
                */
                self.setData([{
                    "id": "1",
                    "caption": "Почта России",
                    "price": default_price,
                    "deliveryTime": 0,
                    "selected": true
                }]);
                self.fire("afterRefresh");
            }
        });
    };

    window.deliveryMethods = new DeliveryMethods();
}(window, jQuery));


$(function () {
    //страница заказа выбор способа доставки
    var $delivery_method = $('.dmethod');
    $delivery_method.change(function () {
        var $all_methods = $('.deliveryMethods');
        var $method = $all_methods.find(':checked');
        if ($method.length === 0) {
            $method = $all_methods.find('.dmethod-item').eq(0).find('.dmethod');
            $method.prop('checked', true);
            return;
        }
        var price = parseInt($method.data('price')),
            price_formatted = formatNumber(price, 0, ',', ' ') + "&nbsp;₽";
        if ($method.data('selected') !== undefined) {
            if ($method.data('selected') == false) {
                price = 0;
                price_formatted = "&mdash;";
            } else if ($method.data('selected') == 2) {
                price = $method.data('price_boxberry');
                price_formatted = formatNumber(price, 0, ',', ' ') + "&nbsp;₽";
            } else if ($method.data('selected') == 3) {
                price = $method.data('price_cdek');
                price_formatted = formatNumber(price, 0, ',', ' ') + "&nbsp;₽";
            }
        }
        window.app.prices.onFieldChanged(function () {
            $('.js-delivery-price').html(price_formatted);
        });
        window.app.prices.deliveryPrice = price;
    });
    $delivery_method.parent().find('label').removeClass('disabled');
    $delivery_method.parent().find('label').removeClass('selected');
    $('.dmethod[disabled=disabled]').parent().find('label').addClass('disabled');
    $('.dmethod:checked').parent().find('label').addClass('selected');
    $delivery_method.change(function () {
        $delivery_method.parent().find('label').removeClass('disabled');
        $delivery_method.parent().find('label').removeClass('selected');
        $('.dmethod[disabled=disabled]').parent().find('label').addClass('disabled');
        $('.dmethod:checked').parent().find('label').addClass('selected');
    });


    let choose_btn = $(".choose_widget__input");
    choose_btn.on('click', function (e) {
        $(this).parents('.choose_widget').addClass('active');
    });
    $(document).mouseup(function (e) {
        if (!choose_btn.is(e.target) && choose_btn.has(e.target).length === 0) {
            choose_btn.parents('.choose_widget').removeClass('active');
        }
    });

    function stickyOrderSidebar() {
        let block = $('.sidebar.order-sidebar .sticky-wrapper'),
            content = $(".order-wrapper .content-wrapper");
        if (block.length !== 0 && content.length !== 0 && $(document).outerWidth() > 768) {
            let block_height = block.outerHeight(),
                content_height = content.outerHeight(),
                start_position = content.offset().top - 80,
                end_position = $("footer").offset().top - block_height - 116;
            if (content_height > block_height + 16) {
                if ($(window).scrollTop() >= start_position && $(window).scrollTop() < end_position) {
                    block.css('position', 'fixed');
                    block.css('top', '80px');
                } else if ($(window).scrollTop() >= end_position) {
                    block.css('position', 'absolute');
                    block.css('top', content_height - block_height + 30);
                } else if ($(window).scrollTop() < start_position) {
                    block.css('position', 'absolute');
                    block.css('top', 'auto');
                }
            }
        }
    }

    $(document).scroll(function () {
        stickyOrderSidebar();
    });

});
